import { render, staticRenderFns } from "./TorneoContextBar.vue?vue&type=template&id=ea6d8636&scoped=true"
import script from "./TorneoContextBar.vue?vue&type=script&lang=js"
export * from "./TorneoContextBar.vue?vue&type=script&lang=js"
import style0 from "./TorneoContextBar.vue?vue&type=style&index=0&id=ea6d8636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6d8636",
  null
  
)

export default component.exports